import { writable, readable } from "svelte/store";
import * as app from "./app.json5";
import * as ciDef from "../public/ci/gcw/gcw.json5";

const setToString = (set) => {
  if (set === null) return null;
  return JSON.stringify([...set]);
};
const stringToSet = (str) => {
  if (str === null) return null;
  return new Set(JSON.parse(str));
};

const saveId = app["save_id"] ? app.save_id : "generic";
export const saveKey = `locked-app-${saveId}-storage`;
const storedFlags = stringToSet(localStorage.getItem(`${saveKey}_flags`));
const storedBenefits = stringToSet(localStorage.getItem(`${saveKey}_benefits`));
const storedNewestSection = localStorage.getItem(`${saveKey}_newest_section`);
const storedCurrentPageIndex = parseInt(localStorage.getItem(`${saveKey}_current_page_index`), 10);
const storedPassword = localStorage.getItem(`${saveKey}_simple_password`);

export const layout = app["layout"] ? app.layout : "scroll";
export const pages = app["pages"] ? app.pages : null;
export const overlay = app["overlay"] ? app.overlay : null;
export const currentPageIndex = writable(storedCurrentPageIndex || 0);
currentPageIndex.subscribe((value) => {
  localStorage.setItem(`${saveKey}_current_page_index`, value);
});
export const usePasswordFile = app["use_password_file"] ? app.use_password_file : false;

export const useGlobalFloatingIcon = app["use_global_floating_icon"]
  ? app.use_global_floating_icon
  : false;

export const flags = writable(storedFlags || new Set());
flags.subscribe((value) => {
  localStorage.setItem(`${saveKey}_flags`, setToString(value));
});
export const benefits = writable(storedBenefits || new Set());
benefits.subscribe((value) => {
  localStorage.setItem(`${saveKey}_benefits`, setToString(value));
});
export const newestSection = writable(storedNewestSection || null);
newestSection.subscribe((value) => {
  localStorage.setItem(`${saveKey}_newest_section`, value);
});
export const password = writable(storedPassword || null);
password.subscribe((value) => {
  localStorage.setItem(`${saveKey}_simple_password`, value);
});
export const hasAccess = writable(false);

export const sections = readable(app["sections"]);
export const benefitsDef = readable(app["benefits"]);
export const ci = writable(ciDef);
export const debug = readable(app["debug"]);

import Zooming from "zooming";
export const zooming = readable(
  new Zooming({
    scaleExtra: 1.66,
    zIndex: 98,
  })
);

export const modal = writable(null);
